import { takeLatest } from 'redux-saga/effects';
import { FieldSectionType } from 'api/field-sections/types';
import { addMultipleSubtasks } from 'collections/tasks';
import { STATUS_FIELD_NAME } from 'data/fields/hooks/account-fields';
import { ACCOUNT_CONFIG_QUERY_KEY } from 'queries/account';
import { getProjectDependencyMapKey } from 'queries/common';
import { logger } from 'services';
import { invalidateTaskQuery } from 'utils/invalidate-task-query';
import { createMultipleSubTasksSagaAction } from '../actions';
function* createMultipleSubTasksSaga(action) {
    var _accountConfig_fields;
    const { payload } = action;
    const { projectId, queryClient, ...rest } = payload;
    const accountConfig = queryClient.getQueryData(ACCOUNT_CONFIG_QUERY_KEY);
    const statusField = accountConfig === null || accountConfig === void 0 ? void 0 : (_accountConfig_fields = accountConfig.fields) === null || _accountConfig_fields === void 0 ? void 0 : _accountConfig_fields.find((f)=>f.fieldName === STATUS_FIELD_NAME && f.objectType === FieldSectionType.Task);
    if (!statusField) {
        return;
    }
    try {
        yield addMultipleSubtasks(rest.parentTask, rest.subtasks.map((e)=>({
                taskName: e.taskName
            })));
        yield queryClient.invalidateQueries(getProjectDependencyMapKey(projectId));
        yield invalidateTaskQuery(rest.parentTask);
    } catch (error) {
        logger.error('createSubTaskSaga failed', {
            error
        });
    }
}
export function* watchCreateMultipleSubTaskSaga() {
    yield takeLatest(createMultipleSubTasksSagaAction.type, createMultipleSubTasksSaga);
}
